import React, { createContext, useContext, useState, useCallback } from 'react';

const ProntuarioContext = createContext(null);

const envBase = process.env.REACT_APP_PRONTUARIO_BASE_URL;
const origin = typeof window !== 'undefined' ? window.location.origin : '';
const isLocal = origin.includes('localhost') || origin.includes('127.0.0.1');
const ALFRESCO_BASE =
  envBase && envBase !== 'undefined'
    ? envBase
    : isLocal
      ? `${origin}/alfresco/api/-default-/public/alfresco/versions/1`
      : 'http://10.0.125.5/alfresco/api/-default-/public/alfresco/versions/1';

const BASIC_AUTH = (() => {
  const user = process.env.REACT_APP_PRONTUARIO_USER ;
  const pass = process.env.REACT_APP_PRONTUARIO_PASS ;
  const cred = `${user}:${pass}`;
  if (typeof btoa === 'function') return `Basic ${btoa(cred)}`;
  if (typeof Buffer !== 'undefined') return `Basic ${Buffer.from(cred).toString('base64')}`;
  return '';
})();

export const ProntuarioProvider = ({ children }) => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const searchProntuario = useCallback(async (term = '') => {
    const query = term?.trim() || '';
    setLoading(true);
    setError(null);
    try {
      const resp = await fetch(
        `${ALFRESCO_BASE}/queries/nodes?term=${encodeURIComponent(query)}`,
        {
          headers: {
            Authorization: BASIC_AUTH,
            Accept: 'application/json',
          },
        }
      );
      if (!resp.ok) {
        throw new Error(`Erro ${resp.status}`);
      }
      const data = await resp.json();
      setResults(data?.list?.entries || []);
      return data?.list?.entries || [];
    } catch (err) {
      console.error('Erro ao buscar prontuário:', err);
      setError('Não foi possível buscar os documentos.');
      setResults([]);
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  const downloadProntuario = useCallback(async (nodeId, filename) => {
    if (!nodeId) return;
    try {
      const resp = await fetch(
        `${ALFRESCO_BASE}/nodes/${nodeId}/content?attachment=true`,
        {
          headers: {
            Authorization: BASIC_AUTH,
            Accept: '*/*',
          },
        }
      );
      if (!resp.ok) throw new Error(`Erro ${resp.status}`);
      const blob = await resp.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename || `${nodeId}.bin`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Erro ao baixar arquivo:', err);
      setError('Não foi possível baixar o arquivo.');
    }
  }, []);

  return (
    <ProntuarioContext.Provider
      value={{
        results,
        setResults,
        loading,
        error,
        searchProntuario,
        downloadProntuario,
      }}
    >
      {children}
    </ProntuarioContext.Provider>
  );
};

export const useProntuario = () => {
  const ctx = useContext(ProntuarioContext);
  if (!ctx) throw new Error('useProntuario deve ser usado dentro de ProntuarioProvider');
  return ctx;
};
